// XX: The file must be .js to be picked up by next-sitemap.config.js

// No index pages are marked as noIndex and noFollow in the `<head>` and excluded from sitemap.
// This hides them from external search engines.
export const noIndexPages = [
  "/events/identity",
  "/events/migration-guide/segment",
  "/events/migration-guide/rudderstack",
  "/events/migration-guide/mparticle",
  "/events/migration-guide/mparticle-braze",
  "/events/migration-guide/amplitude",
  // Identity Resolution pages
  "/identity-resolution/golden-record",
  "/identity-resolution/supercluster",
  "/identity-resolution/identifier-rules",
  "/identity-resolution/overview",
  "/identity-resolution/usage",
  "/identity-resolution/get-started",
  "/identity-resolution/how-it-works",
  "/identity-resolution/deterministic",
  "/identity-resolution/prepare-data",
  "/identity-resolution/identity-graph",
  "/identity-resolution/monitor",
  "/identity-resolution/troubleshooting",
  "/identity-resolution/profile-reprocessing",
  "/identity-resolution/permissions",
  // Probabilistic IDR pages
  "/probabilistic-idr/overview",
  "/probabilistic-idr/aws",
  "/probabilistic-idr/gcs",
  "/probabilistic-idr/azure",
  // Hightouch Real-time pages
  "/real-time/architecture",
  // AI Decisioning pages (private only — public AID pages are indexed normally)
  "/ai-decisioning/security",
  "/ai-decisioning/permissions",
  "/ai-decisioning/user-feature-matrix",
  "/ai-decisioning/group-assignment",
  "/ai-decisioning/smart-suppression",
  // MCP (private beta)
  "/ai-integrations/mcp-server",
  // Agents pages
  "/agents/overview",
  "/agents/chats",
  "/agents/reports",
  "/agents/custom-agents",
  "/agents/settings",
  "/agents/compare-agents",
  // Context Hub pages
  "/context-hub/overview",
  "/context-hub/connections",
  "/context-hub/business-context",
  "/context-hub/brands",
  "/context-hub/creative",
  "/context-hub/guardrails",
  "/context-hub/assets",
  "/context-hub/external",
  // Ad Studio pages
  "/ad-studio/overview",
  "/ad-studio/prompting-guide",
  "/ad-studio/ads",
  "/ad-studio/refine",
  "/ad-studio/launch",
  "/ad-studio/figma",
  "/ad-studio/insights",
    // Workspace management pages
  "/workspace-management/spaces",
  // Lifecycle Studio beta pages
  "/lifecycle-studio/overview",
  "/lifecycle-studio/campaigns",
  "/lifecycle-studio/messages",
  "/lifecycle-studio/dynamic-content",
  "/lifecycle-studio/templates",
  "/lifecycle-studio/images",
  "/lifecycle-studio/asana",
  // Sources (private beta)
  "/sources/query-tags",
  // PubMatic destination (private)
  "/destinations/pubmatic",
  // OpenX destination (private)
  "/destinations/openx",
  // Native Delivery (private)
  "/native-delivery/overview",
  "/native-delivery/push-ios",
  "/native-delivery/push-android",
  "/native-delivery/emails",
  "/native-delivery/sms",
  "/native-delivery/personalization",
  "/native-delivery/preview-and-test",
  "/native-delivery/campaigns",
  "/native-delivery/journeys",
  "/native-delivery/api-triggered-sends",
  "/native-delivery/subscriptions-and-consent",
  "/native-delivery/reporting",
  "/native-delivery/deliverability",
  "/native-delivery/approvals",
  "/native-delivery/suppression-lists",
  "/native-delivery/migration",
];
